export const getInitials = (author: string): string =>
  author
    .split(' ')
    .map((chunk) => chunk[0])
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code >= 65 && code <= 90;
    })
    .join('');
